import { render, staticRenderFns } from "./PostcodeChecker.vue?vue&type=template&id=99f8ebdc&scoped=true&"
import script from "./PostcodeChecker.vue?vue&type=script&lang=js&"
export * from "./PostcodeChecker.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeChecker.vue?vue&type=style&index=0&id=99f8ebdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f8ebdc",
  null
  
)

export default component.exports